import * as e from "react";
import s from "../lib/SSRBase.es.js";
import t from "../defs/Shapes.es.js";
const o = e.forwardRef((a, r) => /* @__PURE__ */ e.createElement(s, { ref: r, ...a, weights: t }));
o.displayName = "ShapesIcon";
const c = o;
export {
  c as Shapes,
  o as ShapesIcon
};
